// Matomo events. Only if window._paq exists, never sends input values.

const sent = new Set();

/** name: optional event name, e.g. a result category – never raw input values. */
export function track(tool, action, name) {
  let paq;
  try {
    paq = window._paq;
  } catch (e) {
    return false;
  }
  if (!paq || typeof paq.push !== 'function') return false;
  // "calculate" once per page view and tool
  if (action === 'calculate') {
    const key = tool + ':calculate';
    if (sent.has(key)) return false;
    sent.add(key);
  }
  paq.push(name ? ['trackEvent', 'Tool', tool, action, name] : ['trackEvent', 'Tool', tool, action]);
  return true;
}
